import {
    FETCH_ROLE_CHECKER_REQUEST,
    FETCH_ROLE_CHECKER_SUCCESS,
    FETCH_ROLE_CHECKER_ERROR,
    HIDE_ROLE_CHECKER_LOADER,
    SHOW_ROLE_CHECKER_LOADER,
    UPDATE_INTENT_REQUEST,
    UPDATE_INTENT_SUCCESS,
    UPDATE_INTENT_ERROR,
} from './roleVerification.constants';

export const fetchRoleCheckerRequest = payload => ({
    type: FETCH_ROLE_CHECKER_REQUEST,
    payload,
});

export const fetchRoleCheckerSuccess = payload => ({
    type: FETCH_ROLE_CHECKER_SUCCESS,
    payload,
});

export const fetchRoleCheckerError = payload => ({
    type: FETCH_ROLE_CHECKER_ERROR,
    payload,
});

// Intent Role
export const updateIntentRequest = payload => ({
    type: UPDATE_INTENT_REQUEST,
    payload,
});

export const updateIntentSuccess = payload => ({
    type: UPDATE_INTENT_SUCCESS,
    payload,
});

export const updateIntentError = payload => ({
    type: UPDATE_INTENT_ERROR,
    payload,
});

export const showLoader = () => ({ type: SHOW_ROLE_CHECKER_LOADER });

export const hideLoader = () => ({ type: HIDE_ROLE_CHECKER_LOADER });
